import React from 'react';

const StatTitle = () => {
    return (
        <div className="statTitle-content">
            <div className="stat-text">
                <h1>Advanced Statistics</h1>
                <p>
                    Track how your links are performing across the web
                    with our advanced statistics dashboard.
                </p>
            </div>
        </div>
    );
};

export default StatTitle;
